export const ColorDescriptions = {
  // =============================
  // 🌸 SPRING (4계절 기본)
  // =============================
  "#FFB3AB": {
    name: "라이트 코랄 핑크",
    tone: "Spring / Light Spring / Bright Spring",
    mood: "화사하고 생기 넘치는 분위기",
    match: ["아이보리", "크림베이지", "코랄립", "샴페인 골드"],
    avoid: ["딥 네이비", "블랙", "퍼플"]
  },
  "#FFD1A9": {
    name: "피치 베이지",
    tone: "Spring / Warm Spring",
    mood: "따뜻하고 부드러운 파스텔 무드",
    match: ["화이트", "라이트 브라운", "골드"],
    avoid: ["쿨그레이", "보라", "청보라"]
  },
  "#FFE596": {
    name: "라이트 옐로우",
    tone: "Spring / Bright Spring",
    mood: "밝고 긍정적인 생기 가득한 색",
    match: ["화이트", "민트", "라이트카멜"],
    avoid: ["블랙", "보라"]
  },
  "#E0FF8A": {
    name: "라임 옐로우",
    tone: "Spring / Bright Spring",
    mood: "상큼하고 에너지 넘침",
    match: ["민트", "라이트 블루", "화이트"],
    avoid: ["카키브라운", "보라"]
  },
  "#A8FFBD": {
    name: "민트 파스텔 그린",
    tone: "Spring / Light Spring",
    mood: "맑고 시원한 느낌",
    match: ["화이트", "샴페인골드", "코랄"],
    avoid: ["바이올렛", "네이비"]
  },
  "#A4F7FF": {
    name: "파스텔 스카이블루",
    tone: "Spring / Bright Spring",
    mood: "맑고 청량한 분위기",
    match: ["화이트", "라일락", "라이트 옐로우"],
    avoid: ["보라", "드라큘라 퍼플"]
  },
  "#C5B3FF": {
    name: "라일락 파스텔",
    tone: "Spring / Light Spring / Light Summer",
    mood: "은은하고 여린 신비감",
    match: ["화이트", "실버", "로즈핑크"],
    avoid: ["카키", "딥브라운"]
  },

  // 🌸 SPRING worst
  "#003366": {
    name: "다크 네이비",
    tone: "Winter / Deep Winter",
    mood: "무겁고 차가운 느낌",
    match: ["화이트", "실버"],
    avoid: ["Spring 전체"]
  },
  "#330044": {
    name: "다크 퍼플",
    tone: "Winter",
    mood: "강렬하고 깊은 인상",
    match: ["블랙", "실버"],
    avoid: ["Spring 전체"]
  },
  "#4B0082": {
    name: "인디고",
    tone: "Winter / Deep Winter",
    mood: "강렬하고 선명함",
    match: ["화이트"],
    avoid: ["스프링 전체"]
  },
  "#000000": {
    name: "블랙",
    tone: "Winter",
    mood: "선명·고대비",
    match: ["실버", "화이트"],
    avoid: ["Spring / Summer 대부분"]
  },

  // =============================
  // ☁ SUMMER (4계절 기본)
  // =============================
  "#C4E3FF": {
    name: "라이트 아이스 블루",
    tone: "Summer / Light Summer",
    mood: "맑고 차분함",
    match: ["실버", "화이트"],
    avoid: ["비비드 오렌지"]
  },
  "#A6D1FF": {
    name: "파스텔 스카이",
    tone: "Summer",
    mood: "부드럽고 시원함",
    match: ["화이트", "쿨그레이"],
    avoid: ["브라운 계열"]
  },
  "#D3C7FF": {
    name: "라벤더 라이트",
    tone: "Summer / Cool Summer",
    mood: "은은한 로맨틱함",
    match: ["화이트", "실버"],
    avoid: ["노란기 강한 베이지"]
  },
  "#FFC4D6": {
    name: "로지 핑크",
    tone: "Summer",
    mood: "청순하고 부드러운 무드",
    match: ["화이트", "라이트 블루"],
    avoid: ["브라운", "오렌지"]
  },
  "#FFE8E3": {
    name: "페일 로즈",
    tone: "Summer",
    mood: "잔잔하고 고급스러움",
    match: ["실버", "쿨 그레이"],
    avoid: ["카멜", "브라운"]
  },
  "#F4F7FF": {
    name: "아이스 화이트",
    tone: "Summer / Winter",
    mood: "차갑고 맑은 느낌",
    match: ["실버", "네이비"],
    avoid: ["아이보리", "노란기 화이트"]
  },

  // SUMMER worst
  "#FF6600": {
    name: "비비드 오렌지",
    tone: "Spring / Autumn",
    mood: "강렬한 에너지",
    match: ["블랙"],
    avoid: ["Summer 전체"]
  },
  "#663300": {
    name: "다크 브라운",
    tone: "Autumn",
    mood: "깊고 따뜻함",
    match: ["베이지"],
    avoid: ["Summer 전체"]
  },
  "#552200": {
    name: "초콜릿 브라운",
    tone: "Autumn / Deep Autumn",
    mood: "묵직하고 차분함",
    match: ["카멜"],
    avoid: ["Summer 전체"]
  },

  // =============================
  // 🍂 AUTUMN (4계절)
  // =============================
  "#CC5500": {
    name: "번트 오렌지",
    tone: "Warm Autumn",
    mood: "고급스럽고 깊은 분위기",
    match: ["카멜", "카키"],
    avoid: ["쿨블루", "실버"]
  },
  "#B5651D": {
    name: "따뜻한 카멜 오렌지",
    tone: "Autumn",
    mood: "편안하고 안정적",
    match: ["베이지", "올리브"],
    avoid: ["블루계열"]
  },
  "#A97142": {
    name: "카멜 브라운",
    tone: "Autumn",
    mood: "고급스러운 클래식 무드",
    match: ["아이보리", "올리브"],
    avoid: ["쿨그레이"]
  },
  "#D2691E": {
    name: "시나몬",
    tone: "Warm Autumn",
    mood: "따뜻하고 깊은 매력",
    match: ["카멜", "버건디"],
    avoid: ["블루톤"]
  },
  "#8B4513": {
    name: "브라운 우드",
    tone: "Deep Autumn",
    mood: "무게감 있고 깊음",
    match: ["카키"],
    avoid: ["쿨톤 전체"]
  },
  "#C19A6B": {
    name: "모카베이지",
    tone: "Autumn",
    mood: "따뜻하고 부드러운 느낌",
    match: ["버건디", "올리브"],
    avoid: ["쿨핑크"]
  },

  // AUTUMN worst
  "#66CCFF": {
    name: "라이트 시안",
    tone: "Summer / Winter",
    mood: "시원하고 청량함",
    match: ["화이트"],
    avoid: ["Autumn 전체"]
  },
  "#99DDFF": {
    name: "파우더 블루",
    tone: "Summer",
    mood: "부드럽고 청량함",
    match: ["화이트"],
    avoid: ["Autumn 전체"]
  },
  "#CCEEFF": {
    name: "아쿠아 라이트",
    tone: "Summer",
    mood: "맑고 투명함",
    match: ["실버"],
    avoid: ["Autumn"]
  },
  "#FFFFFF": {
    name: "퓨어 화이트",
    tone: "Winter",
    mood: "선명함, 고대비",
    match: ["블랙", "실버"],
    avoid: ["Autumn 전체"]
  },

  // =============================
  // ❄ WINTER 4계절
  // =============================
  "#00008B": {
    name: "딥 네이비",
    tone: "Winter / Deep Winter",
    mood: "선명하고 강렬함",
    match: ["화이트", "실버"],
    avoid: ["웜베이지"]
  },
  "#9932CC": {
    name: "바이올렛",
    tone: "Winter",
    mood: "선명하고 화려함",
    match: ["블랙"],
    avoid: ["노란계열"]
  },
  "#00FFFF": {
    name: "시안",
    tone: "Winter / Bright Winter",
    mood: "차갑고 선명함",
    match: ["블랙", "화이트"],
    avoid: ["브라운"]
  },
  "#FF1493": {
    name: "딥 핑크",
    tone: "Bright Winter",
    mood: "강렬하고 화려함",
    match: ["블랙", "실버"],
    avoid: ["브라운"]
  },

  // =============================
  // ⭐ 12톤 팔레트 전체 (Spring ~ Winter)
  // =============================

  // --- Bright Spring
  "#FF6F61": {
    name: "브라이트 코랄",
    tone: "Bright Spring",
    mood: "화사하고 비비드함",
    match: ["화이트"],
    avoid: ["보라"]
  },
  "#FFA177": {
    name: "라이트 오렌지 코랄",
    tone: "Bright Spring",
    mood: "생동감 넘침",
    match: ["아이보리"],
    avoid: ["보라"]
  },
  "#FFD479": {
    name: "라이트 옐로우 브라이트",
    tone: "Bright Spring",
    mood: "화려하고 따뜻함",
    match: ["화이트"],
    avoid: ["보라"]
  },
  "#8FFFBD": {
    name: "브라이트 민트",
    tone: "Bright Spring",
    mood: "상큼한 청량함",
    match: ["화이트"],
    avoid: ["딥브라운"]
  },
  "#6FE7FF": {
    name: "브라이트 시안",
    tone: "Bright Spring",
    mood: "맑고 시원함",
    match: ["화이트"],
    avoid: ["보라", "카키"]
  },

  // --- Light Spring
  "#FFCCB3": {
    name: "파스텔 코랄",
    tone: "Light Spring",
    mood: "은은하고 귀여운 분위기",
    match: ["화이트"],
    avoid: ["딥 네이비"]
  },
  "#FFE3A4": {
    name: "파스텔 옐로우",
    tone: "Light Spring",
    mood: "따뜻함 + 생기",
    match: ["민트"],
    avoid: ["보라"]
  },
  "#FFF7B2": {
    name: "페일 아이보리 옐로우",
    tone: "Light Spring",
    mood: "부드럽고 화사함",
    match: ["화이트"],
    avoid: ["네이비"]
  },
  "#C1FFCF": {
    name: "라이트 민트",
    tone: "Light Spring",
    mood: "맑고 산뜻함",
    match: ["크림"],
    avoid: ["카키"]
  },
  "#C6F7FF": {
    name: "페일 블루 민트",
    tone: "Light Spring",
    mood: "맑고 청량함",
    match: ["화이트"],
    avoid: ["보라"]
  },

  // --- Warm Spring
  "#E89B61": {
    name: "웜 코랄 브라운",
    tone: "Warm Spring",
    mood: "따뜻하고 생기있음",
    match: ["아이보리"],
    avoid: ["보라"]
  },
  "#FFBE7A": {
    name: "피치 오렌지",
    tone: "Warm Spring",
    mood: "활발하고 따뜻함",
    match: ["크림베이지"],
    avoid: ["퍼플"]
  },
  "#FFD68A": {
    name: "웜 페일 옐로우",
    tone: "Warm Spring",
    mood: "밝고 생기",
    match: ["화이트"],
    avoid: ["보라"]
  },
  "#D1FF8A": {
    name: "웜 라임 옐로우",
    tone: "Warm Spring",
    mood: "상큼한 에너지",
    match: ["민트"],
    avoid: ["카키"]
  },

  // --- Bright Summer
  "#D4E8FF": {
    name: "라이트 블루 톤",
    tone: "Bright Summer",
    mood: "맑고 청량한 쿨톤",
    match: ["실버"],
    avoid: ["브라운"]
  },
  "#B9D4FF": {
    name: "파스텔 쿨 블루",
    tone: "Bright Summer",
    mood: "부드럽고 깨끗함",
    match: ["화이트"],
    avoid: ["브라운"]
  },
  "#E3D7FF": {
    name: "라일락 쿨",
    tone: "Bright Summer",
    mood: "청량 + 로맨틱",
    match: ["실버"],
    avoid: ["노란기 강한 색"]
  },
  "#FFD4E8": {
    name: "쿨 핑크 라이트",
    tone: "Bright Summer",
    mood: "맑고 산뜻함",
    match: ["화이트"],
    avoid: ["브라운"]
  },

  // --- Soft Summer
  "#C7C8D9": {
    name: "더스티 블루 그레이",
    tone: "Soft Summer",
    mood: "차분하고 부드러움",
    match: ["실버"],
    avoid: ["비비드 오렌지"]
  },
  "#D6CEDB": {
    name: "더스티 라벤더",
    tone: "Soft Summer",
    mood: "우아하고 잔잔함",
    match: ["쿨 그레이"],
    avoid: ["브라운"]
  },
  "#E7D8E9": {
    name: "파스텔 라일락",
    tone: "Soft Summer",
    mood: "잔잔하고 부드러운 무드",
    match: ["화이트"],
    avoid: ["카멜"]
  },
  "#F5DFE6": {
    name: "페일 로즈",
    tone: "Soft Summer",
    mood: "부드럽고 은은함",
    match: ["실버"],
    avoid: ["브라운"]
  },

  // --- Light Summer
  "#DDEBFA": {
    name: "파스텔 블루",
    tone: "Light Summer",
    mood: "청량하고 순함",
    match: ["화이트"],
    avoid: ["브라운"]
  },
  "#CDE0F7": {
    name: "라이트 아이스 블루",
    tone: "Light Summer",
    mood: "맑고 투명함",
    match: ["실버"],
    avoid: ["노란기 베이지"]
  },
  "#ECDCF8": {
    name: "페일 라일락",
    tone: "Light Summer",
    mood: "부드럽고 은은한 쿨톤",
    match: ["화이트"],
    avoid: ["브라운"]
  },
  "#FBE6F1": {
    name: "연한 로즈 핑크",
    tone: "Light Summer",
    mood: "여리고 깨끗한 느낌",
    match: ["화이트"],
    avoid: ["딥브라운"]
  },

  // --- Warm Autumn
  "#D77F47": {
    name: "웜 브라운 오렌지",
    tone: "Warm Autumn",
    mood: "따뜻하고 고급스러움",
    match: ["베이지"],
    avoid: ["쿨 블루"]
  },
  "#BF6B3F": {
    name: "브라운 코랄",
    tone: "Warm Autumn",
    mood: "부드럽고 깊은 매력",
    match: ["카멜"],
    avoid: ["쿨핑크"]
  },
  "#D9A066": {
    name: "테라코타 베이지",
    tone: "Warm Autumn",
    mood: "고급스러운 웜톤",
    match: ["올리브"],
    avoid: ["쿨블루"]
  },
  "#C39B6B": {
    name: "웜 모카",
    tone: "Warm Autumn",
    mood: "부드럽고 따뜻함",
    match: ["카멜"],
    avoid: ["쿨핑크"]
  },

  // --- Soft Autumn
  "#C1A083": {
    name: "부드러운 모카톤",
    tone: "Soft Autumn",
    mood: "잔잔하고 차분함",
    match: ["베이지"],
    avoid: ["비비드 블루"]
  },
  "#D2B48C": {
    name: "탄 베이지",
    tone: "Soft Autumn",
    mood: "부드럽고 따뜻함",
    match: ["브라운"],
    avoid: ["쿨톤"]
  },
  "#E3C6A8": {
    name: "소프트 베이지",
    tone: "Soft Autumn",
    mood: "따뜻하고 내추럴",
    match: ["카키"],
    avoid: ["블루"]
  },
  "#D8C3A5": {
    name: "라이트 카푸치노",
    tone: "Soft Autumn",
    mood: "따뜻하고 은은함",
    match: ["브라운"],
    avoid: ["쿨핑크"]
  },

  // --- Deep Autumn
  "#8C4B1F": {
    name: "딥 브라운",
    tone: "Deep Autumn",
    mood: "무게감, 깊은 카리스마",
    match: ["카키"],
    avoid: ["라이트 블루"]
  },
  "#6A3A1C": {
    name: "차콜 브라운",
    tone: "Deep Autumn",
    mood: "고급스러운 따뜻함",
    match: ["베이지"],
    avoid: ["쿨핑크"]
  },
  "#A65E2E": {
    name: "테라코타 브라운",
    tone: "Deep Autumn",
    mood: "선명하고 따뜻함",
    match: ["올리브"],
    avoid: ["쿨톤"]
  },
  "#C2763E": {
    name: "소프트 오렌지 브라운",
    tone: "Deep Autumn",
    mood: "풍부하고 깊은 색감",
    match: ["카멜"],
    avoid: ["쿨블루"]
  },

  // --- Bright Winter
  "#00D4FF": {
    name: "브라이트 시안",
    tone: "Bright Winter",
    mood: "청량하고 선명함",
    match: ["블랙", "화이트"],
    avoid: ["브라운"]
  },
  "#008CFF": {
    name: "브라이트 블루",
    tone: "Bright Winter",
    mood: "차갑고 강렬함",
    match: ["화이트"],
    avoid: ["브라운"]
  },
  "#B400FF": {
    name: "브라이트 퍼플",
    tone: "Bright Winter",
    mood: "화려하고 선명함",
    match: ["블랙"],
    avoid: ["베이지"]
  },
  "#FF007F": {
    name: "브라이트 핑크",
    tone: "Bright Winter",
    mood: "강렬하고 화려한 인상",
    match: ["블랙"],
    avoid: ["브라운"]
  },

  // --- Cool Winter
  "#0022FF": {
    name: "쿨 로열 블루",
    tone: "Cool Winter",
    mood: "선명하고 시원함",
    match: ["화이트"],
    avoid: ["브라운"]
  },
  "#4B00CC": {
    name: "쿨 퍼플",
    tone: "Cool Winter",
    mood: "차갑고 선명함",
    match: ["화이트"],
    avoid: ["베이지"]
  },
  "#AA00FF": {
    name: "네온 퍼플",
    tone: "Cool Winter",
    mood: "강렬하고 화려함",
    match: ["블랙"],
    avoid: ["브라운"]
  },


  // --- Deep Winter
  "#000033": {
    name: "딥 네이비 블랙",
    tone: "Deep Winter",
    mood: "강렬하고 고급스러움",
    match: ["화이트", "실버"],
    avoid: ["베이지"]
  },
  "#220044": {
    name: "딥 퍼플 네이비",
    tone: "Deep Winter",
    mood: "차갑고 화려함",
    match: ["화이트"],
    avoid: ["브라운"]
  },
  "#550087": {
    name: "딥 바이올렛",
    tone: "Deep Winter",
    mood: "선명하고 럭셔리함",
    match: ["실버"],
    avoid: ["노란계열"]
  },
  "#8800CC": {
    name: "딥 퍼플",
    tone: "Deep Winter",
    mood: "고대비, 강렬함",
    match: ["화이트"],
    avoid: ["베이지"]
  },

  "#000044": {
  name: "딥 네이비 블루",
  tone: "Cool / Deep Summer",
  mood: "어두운 시원함",
  match: ["화이트", "실버"],
  avoid: ["옐로우", "라이트톤"]
},

"#002244": {
  name: "딥 블루 미드나잇",
  tone: "Cool / Winter",
  mood: "차갑고 깊은 색감",
  match: ["화이트"],
  avoid: ["베이지", "브라운"]
},

"#003344": {
  name: "딥 그린 블루",
  tone: "Cool Winter",
  mood: "시크하고 선명함",
  match: ["화이트"],
  avoid: ["웜톤 전체"]
},

"#003355": {
  name: "네이비 틸",
  tone: "Deep Winter",
  mood: "시원하고 강렬함",
  match: ["실버"],
  avoid: ["브라운"]
},

"#220033": {
  name: "다크 퍼플 네이비",
  tone: "Deep Winter",
  mood: "신비롭고 고대비",
  match: ["화이트"],
  avoid: ["브라운"]
},

// 2) Autumn / 브라운 계열
"#330000": {
  name: "딥 와인 브라운",
  tone: "Deep Autumn",
  mood: "묵직하고 클래식",
  match: ["카멜", "올리브"],
  avoid: ["쿨블루"]
},

"#332200": {
  name: "다크 브라운 카키",
  tone: "Soft Autumn / Deep Autumn",
  mood: "내추럴하고 안정감",
  match: ["베이지"],
  avoid: ["블루톤"]
},

"#553300": {
  name: "웜 초코 브라운",
  tone: "Warm Autumn",
  mood: "부드럽고 따뜻함",
  match: ["베이지", "카멜"],
  avoid: ["쿨그레이"]
},

"#996633": {
  name: "라이트 카라멜 브라운",
  tone: "Warm Autumn",
  mood: "부드럽고 따뜻함",
  match: ["카키", "버건디"],
  avoid: ["쿨블루"]
},

// 3) Warm / Spring / Autumn 계열
"#CC6600": {
  name: "브라이트 오렌지 브라운",
  tone: "Warm Autumn",
  mood: "강렬하고 따뜻함",
  match: ["베이지"],
  avoid: ["쿨톤"]
},

"#CC9900": {
  name: "머스타드 골드",
  tone: "Autumn",
  mood: "고급스럽고 따뜻함",
  match: ["브라운", "카멜"],
  avoid: ["쿨핑크"]
},

"#FF5500": {
  name: "비비드 레드 오렌지",
  tone: "Warm Spring / Autumn",
  mood: "강렬한 에너지",
  match: ["블랙"],
  avoid: ["Summer 전체"]
},

"#FFCC66": {
  name: "라이트 머스타드 옐로우",
  tone: "Warm Spring",
  mood: "따뜻하고 밝음",
  match: ["화이트", "라이트 브라운"],
  avoid: ["퍼플"]
},

"#FFDD88": {
  name: "파스텔 머스타드",
  tone: "Warm Spring / Soft Autumn",
  mood: "부드럽고 따뜻함",
  match: ["베이지"],
  avoid: ["블루톤"]
}
  

};
